import produce from 'immer';

import type { Action } from 'Lib/reduxType';

import {
  FETCH_EMAIL_SUBSCRIPTIONS,
  FETCH_EMAIL_SUBSCRIPTIONS_ERROR,
  FETCH_EMAIL_SUBSCRIPTIONS_SUCCESS,
  SET_USER_TOKEN_ERROR,
  SET_USER_TOKEN_SUCCESS,
  UPDATE_EMAIL_SUBSCRIPTIONS_ERROR,
  UPDATE_EMAIL_SUBSCRIPTIONS_SUCCESS,
} from './constants';
import initialState from './initialState';
import type { EmailSubscriptionManagementState as EmailState } from './types';

export const reducer = produce<EmailState, [Action]>((draft, action) => {
  switch (action.type) {
    case FETCH_EMAIL_SUBSCRIPTIONS: {
      draft.hasFetched = true;
      break;
    }
    case UPDATE_EMAIL_SUBSCRIPTIONS_SUCCESS: {
      draft.isUpdating = false;
      break;
    }
    case SET_USER_TOKEN_SUCCESS: {
      draft.isError = false;
      draft.userToken = action.payload.token;
      break;
    }
    case FETCH_EMAIL_SUBSCRIPTIONS_SUCCESS: {
      draft.isError = false;
      draft.isUpdating = true;
      draft.subscriptions = action.payload.subscriptions;
      break;
    }
    case SET_USER_TOKEN_ERROR:
    case FETCH_EMAIL_SUBSCRIPTIONS_ERROR:
    case UPDATE_EMAIL_SUBSCRIPTIONS_ERROR: {
      draft.isError = true;
      break;
    }
    default: {
      break;
    }
  }
}, initialState);
